const RADIUS_METERS = 1000;
const DIRECT_COMPETITION_RADIUS_METERS = 5000;

const normalize = (text) =>
  (text || "")
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();

const businessProfiles = [
  {
    key: "barberia",
    aliases: [
      "barberia",
      "barberias",
      "barber",
      "barbershop",
      "estetica",
      "esteticas",
      "salon",
      "salon de belleza",
      "belleza",
      "peluqueria",
      "peluquerias",
      "corte de pelo",
      "corte de cabello",
      "tinte",
      "alisado",
      "barba",
    ],
    tags: [
      "hairdresser",
      "beauty",
      "hair_care",
      "hair_salon",
      "barber",
      "barbershop",
    ],
    label: "Barberias, esteticas y salones de belleza",
    googleQueries: [
      "barberia",
      "barbershop",
      "estetica corte de cabello",
      "salon de belleza cabello",
      "peluqueria",
    ],
    googleLegacyQueries: [
      "barberia",
      "estetica corte de cabello",
      "salon de belleza cabello",
      "peluqueria",
    ],
    googleNearbyTypes: ["hair_care"],
    nearbyNameKeywords: [
      "barberia",
      "barber",
      "barbershop",
      "estetica",
      "salon de belleza",
      "peluqueria",
      "corte",
      "cabello",
      "pelo",
      "barba",
      "tinte",
      "alisado",
    ],
    strictDirectMatch: true,
    excludeDirectKeywords: [
      "spa",
      "masaje",
      "massage",
      "facial",
      "cosmetologia",
      "cosmetologa",
      "skin care",
      "skincare",
      "wellness",
      "bienestar",
      "terapia",
      "terapias",
      "tratamiento corporal",
      "depilacion",
      "manicure",
      "pedicure",
      "aromaterapia",
      "rejuvenecimiento",
    ],
  },
  {
    key: "spa",
    aliases: [
      "spa",
      "masaje",
      "masajes",
      "massage",
      "facial",
      "faciales",
      "terapia",
      "terapias",
      "cosmetologia",
      "cosmetologa",
      "cosmetologas",
      "skin care",
      "skincare",
      "wellness",
      "centro de bienestar",
      "bienestar",
      "tratamientos corporales",
      "tratamiento corporal",
      "depilacion",
      "manicure",
      "pedicure",
      "aromaterapia",
      "rejuvenecimiento",
    ],
    tags: [
      "spa",
      "massage",
      "wellness",
      "skin care",
      "skincare",
      "facial",
      "cosmetologia",
      "beauty",
      "nails",
    ],
    label: "Spa, cosmetologia y bienestar",
    googleQueries: [
      "spa",
      "masajes",
      "faciales",
      "cosmetologia",
      "skin care",
      "wellness",
      "centro de bienestar",
      "tratamientos corporales",
      "depilacion",
      "manicure pedicure",
    ],
    googleLegacyQueries: [
      "spa",
      "masajes",
      "faciales",
      "cosmetologia",
      "skin care",
      "wellness",
    ],
    googleNearbyTypes: ["spa"],
    nearbyNameKeywords: [
      "spa",
      "masaje",
      "masajes",
      "massage",
      "facial",
      "faciales",
      "cosmetologia",
      "cosmetologa",
      "skin care",
      "skincare",
      "wellness",
      "bienestar",
      "tratamiento corporal",
      "depilacion",
      "manicure",
      "pedicure",
      "aromaterapia",
      "rejuvenecimiento",
    ],
    strictDirectMatch: true,
    excludeDirectKeywords: [
      "barberia",
      "barber",
      "barbershop",
      "peluqueria",
      "corte de cabello",
      "corte de pelo",
      "tinte",
      "alisado",
      "barba",
    ],
  },
  {
    key: "artes_marciales",
    aliases: [
      "escuela de karate",
      "karate",
      "taekwondo",
      "tae kwon do",
      "artes marciales",
      "dojo",
      "mma",
      "judo",
      "box",
      "boxeo",
      "kickboxing",
    ],
    tags: [
      "karate",
      "taekwondo",
      "martial_arts",
      "dojo",
      "judo",
      "boxing",
      "kickboxing",
    ],
    label: "Karate, taekwondo y artes marciales",
    googleQueries: ["karate", "taekwondo", "artes marciales", "dojo"],
  },
  {
    key: "sushi",
    aliases: [
      "sushi",
      "sushis",
      "comida japonesa",
      "japonesa",
      "rollos",
      "roll",
      "restaurante japones",
      "restaurante japonés",
    ],
    tags: [
      "sushi",
      "japanese",
      "asian",
    ],
    label: "Sushi y comida japonesa",
    googleQueries: [
      "sushi",
      "sushis",
      "sushi cerca",
      "restaurante sushi",
      "sushi a domicilio",
      "sushi restaurante",
      "roll sushi",
      "rolls sushi",
      "comida japonesa",
      "japonesa sushi",
      "restaurante japones",
      "rollos japoneses",
      "besachi sushi",
      "yukan roll",
      "japanese restaurant",
      "barra de sushi",
      "sushi bar",
    ],
    googleLegacyQueries: [
      "sushi",
      "sushis",
      "roll",
      "comida japonesa",
      "restaurante japones",
    ],
    googleNearbyTypes: [
      "sushi_restaurant",
      "japanese_restaurant",
      "asian_restaurant",
      "restaurant",
    ],
    nearbyNameKeywords: [
      "sushi",
      "sushis",
      "roll",
      "rolls",
      "yukan",
      "besachi",
      "japonesa",
      "japones",
      "japanese",
      "tabu",
      "kento",
      "ricebox",
      "kyumo",
      "noriko",
      "kinjo",
      "tanoshii",
      "kiin",
      "mosai",
      "kaori",
      "kamado",
      "kippu",
    ],
    strictDirectMatch: true,
    excludeDirectKeywords: [
      "taco",
      "tacos",
      "taqueria",
      "marisco",
      "mariscos",
      "ceviche",
      "camaron",
      "camarones",
      "hamburguesa",
      "pizza",
      "pollo",
      "hot dog",
      "birria",
    ],
  },
  {
    key: "cafeteria",
    aliases: [
      "cafeteria",
      "cafeterias",
      "cafe",
      "coffee",
      "pasteleria",
      "reposteria",
      "panaderia",
      "panaderias",
      "pasteles",
      "postres",
    ],
    tags: [
      "cafe",
      "cafeteria",
      "coffee",
      "bakery",
      "pastry",
      "pasteleria",
      "reposteria",
      "dessert",
    ],
    label: "Cafeterias, pastelerias y cafe",
    googleQueries: ["cafeteria", "cafe", "coffee shop", "pasteleria", "reposteria"],
    googleLegacyQueries: ["cafeteria", "cafe", "coffee shop", "pasteleria", "reposteria"],
    googleNearbyTypes: ["cafe", "bakery"],
    nearbyNameKeywords: [
      "cafe",
      "café",
      "coffee",
      "mocca",
      "moka",
      "pasteleria",
      "pastelería",
      "reposteria",
      "repostería",
      "panaderia",
      "panadería",
      "postre",
      "postres",
      "cake",
      "bakery",
    ],
    strictDirectMatch: true,
    excludeDirectKeywords: [
      "farmacia",
      "pharmacy",
      "benavides",
      "abarrotes",
      "minisuper",
      "mini super",
      "supermercado",
      "convenience_store",
      "grocery_store",
      "kiosko",
      "tiendas chata",
      "casa ley",
      "ley super",
      "oxxo",
      "taqueria",
      "tacos",
      "mariscos",
      "sushi",
      "hamburguesa",
      "pizza",
    ],
  },
  {
    key: "comida",
    aliases: [
      "restaurante",
      "restaurantes",
      "comida",
      "taqueria",
      "taquerias",
      "hamburguesas",
      "pizzeria",
      "pizzerias",
      "fonda",
      "fondas",
      "cocina economica",
      "cocinas economicas",
      "delivery",
      "comida corrida",
      "comida rapida",
    ],
    tags: [
      "restaurant",
      "fast_food",
      "food",
      "pizza",
      "burger",
      "tacos",
      "meal_takeaway",
      "meal_delivery",
      "fonda",
      "cocina",
    ],
    label: "Restaurantes y negocios de comida",
    googleQueries: [
      "restaurante",
      "comida",
      "cocina economica",
      "fonda",
      "comida corrida",
      "comida rapida",
      "delivery comida",
      "taqueria",
      "hamburguesas",
      "pizzeria",
    ],
    googleLegacyQueries: [
      "restaurante",
      "cocina economica",
      "fonda",
      "comida corrida",
      "comida rapida",
      "taqueria",
      "hamburguesas",
      "pizzeria",
    ],
    googleNearbyTypes: [
      "restaurant",
      "mexican_restaurant",
      "fast_food_restaurant",
      "meal_takeaway",
      "pizza_restaurant",
    ],
    nearbyNameKeywords: [
      "restaurante",
      "restaurant",
      "comida",
      "cocina",
      "fonda",
      "taqueria",
      "taquería",
      "taco",
      "tacos",
      "hamburguesa",
      "burger",
      "pizzeria",
      "pizza",
      "mariscos",
      "asadero",
      "antojitos",
      "delivery",
    ],
    strictDirectMatch: true,
    excludeDirectKeywords: [
      "farmacia",
      "pharmacy",
      "benavides",
      "abarrotes",
      "minisuper",
      "mini super",
      "supermercado",
      "convenience_store",
      "grocery_store",
      "kiosko",
      "tiendas chata",
      "casa ley",
      "ley super",
      "oxxo",
      "papeleria",
      "ferreteria",
      "salon",
      "barberia",
    ],
  },
  {
    key: "farmacia",
    aliases: [
      "farmacia",
      "farmacias",
      "farmaica",
      "farmaicas",
      "pharmacy",
    ],
    tags: [
      "pharmacy",
      "chemist",
      "drugstore",
    ],
    label: "Farmacias",
    googleQueries: ["farmacia", "drugstore", "pharmacy"],
    strictDirectMatch: true,
    excludeDirectKeywords: [
      "dentista",
      "dental",
      "odontologo",
      "odontologia",
      "nutriologa",
      "nutriologo",
      "nutricion",
      "nutricionista",
      "spa",
      "belleza",
      "estetica",
    ],
  },
  {
    key: "ferreteria",
    aliases: [
      "ferreteria",
      "ferreterias",
      "hardware",
      "herramientas",
      "materiales",
      "materiales de construccion",
      "materiales de construcción",
      "construccion",
      "construcción",
      "pintura",
      "electricos",
      "eléctricos",
      "plomeria",
      "plomería",
    ],
    tags: [
      "hardware",
      "doityourself",
      "tools",
      "trade",
      "building_materials",
      "paint",
      "electrical",
      "plumbing",
      "construction",
    ],
    label: "Ferreterias, herramientas y materiales",
    googleQueries: [
      "ferreteria",
      "materiales de construccion",
      "herramientas",
      "pintura",
    ],
  },
  {
    key: "consultorio",
    aliases: ["consultorio", "clinica", "doctor", "medico"],
    tags: ["doctors", "clinic", "hospital", "medical"],
    label: "Consultorios y clinicas",
    googleQueries: ["consultorio medico", "clinica medica", "doctor"],
  },
  {
    key: "oficina",
    aliases: ["oficina", "despacho", "corporativo"],
    tags: ["office", "company", "coworking"],
    label: "Oficinas",
    googleQueries: ["oficina", "despacho", "coworking", "corporativo"],
  },
  {
    key: "gimnasio",
    aliases: ["gimnasio", "gym", "fitness"],
    tags: ["fitness_centre", "sports_centre"],
    label: "Gimnasios",
    googleQueries: ["gimnasio", "fitness", "crossfit", "centro deportivo"],
  },
  {
    key: "ropa",
    aliases: [
      "ropa",
      "tienda de ropa",
      "boutique",
      "boutiques",
      "moda",
      "ropa de caballero",
      "ropa de dama",
      "ropa para ninos",
      "ropa para niños",
      "ropa infantil",
      "clothing",
      "apparel",
      "fashion",
      "zapateria",
      "zapaterias",
      "calzado",
      "shoe store",
    ],
    tags: [
      "clothing_store",
      "clothing",
      "apparel",
      "fashion",
      "shoe_store",
      "shoes",
      "boutique",
      "store",
    ],
    label: "Ropa, boutiques y calzado",
    googleQueries: [
      "tienda de ropa",
      "boutique",
      "boutique de ropa",
      "ropa de caballero",
      "ropa de dama",
      "ropa para ninos",
      "ropa infantil",
      "zapateria",
      "tienda de zapatos",
      "clothing store",
      "moda",
    ],
    googleLegacyQueries: [
      "tienda de ropa",
      "boutique",
      "ropa dama",
      "ropa caballero",
      "ropa infantil",
      "zapateria",
      "clothing store",
      "moda",
    ],
    googleNearbyTypes: ["clothing_store", "shoe_store", "department_store", "store"],
    nearbyNameKeywords: [
      "ropa",
      "boutique",
      "moda",
      "caballero",
      "dama",
      "ninos",
      "niños",
      "infantil",
      "zapateria",
      "zapatos",
      "calzado",
      "tenis",
      "fashion",
      "apparel",
      "clothing",
      "department_store",
      "coppel",
      "woolworth",
      "suburbia",
      "milano",
      "del sol",
      "cya",
      "c&a",
      "vertiche",
      "aldo conti",
      "optima",
      "dpstreet",
    ],
    strictDirectMatch: true,
    excludeDirectKeywords: [
      "abarrotes",
      "minisuper",
      "mini super",
      "supermercado",
      "convenience_store",
      "grocery_store",
      "oxxo",
      "kiosko",
      "restaurant",
      "restaurante",
      "meal_takeaway",
      "cafe",
      "bakery",
      "farmacia",
      "pharmacy",
      "papeleria",
      "ferreteria",
    ],
    deprioritizedNameKeywords: [
      "coppel",
      "woolworth",
      "suburbia",
      "milano",
      "del sol",
      "cya",
      "c&a",
    ],
  },
  {
    key: "tienda",
    aliases: ["tienda", "abarrotes", "market", "super", "minisuper", "mini super"],
    tags: ["convenience", "supermarket", "greengrocer", "grocery", "store"],
    label: "Tiendas y abarrotes",
    googleQueries: [
      "tienda",
      "abarrotes",
      "minisuper",
      "mini super",
      "supermercado",
      "mini super la mas querida",
    ],
    strictDirectMatch: true,
    excludeDirectKeywords: [
      "restaurant",
      "restaurante",
      "meal_takeaway",
      "cafe",
      "bakery",
      "farmacia",
      "pharmacy",
      "drugstore",
      "papeleria",
      "stationery",
      "copy",
      "ferreteria",
      "ferretería",
      "ferrereria",
      "hardware",
      "building_materials",
      "materiales",
      "taco",
      "taqueria",
      "asadero",
      "ensalada",
      "ensaladas",
      "salad",
      "marisco",
      "sushi",
      "hamburguesa",
      "pizza",
    ],
  },
  {
    key: "papeleria",
    aliases: ["papeleria", "copy", "copias", "imprenta"],
    tags: ["stationery", "copyshop", "printer"],
    label: "Papelerias e imprentas",
    googleQueries: ["papeleria", "copias", "imprenta", "copy"],
  },
  {
    key: "yonke",
    aliases: [
      "yonke",
      "yonkes",
      "yunque",
      "yunkes",
      "deshuesadero",
      "deshuesaderos",
      "autopartes usadas",
      "auto partes usadas",
      "autopartes",
      "auto parts",
      "auto_parts_store",
      "refacciones usadas",
      "refacciones",
      "repuesto",
      "repuestos",
      "tienda de repuestos",
      "accesorios para automoviles",
      "accesorios para autos",
      "accesorios para camiones",
      "accesorios para trailers",
      "truck accessories",
      "partes para camiones",
      "partes para trailers",
      "partes usadas",
      "partes de auto usadas",
      "auto salvage",
      "junkyard",
      "used auto parts",
    ],
    tags: [
      "junkyard",
      "scrap",
      "salvage",
      "deshuesadero",
    ],
    label: "Yonkes, repuestos, refacciones y autopartes",
    googleQueries: [
      "yonke",
      "yunque de autos",
      "deshuesadero",
      "autopartes usadas",
      "refacciones usadas",
      "tienda de repuestos para automoviles",
      "tienda de accesorios para automoviles",
      "tienda de accesorios para camiones",
      "refaccionaria",
      "autopartes",
      "partes para camiones y trailers",
      "auto parts store",
      "used auto parts",
    ],
    googleLegacyQueries: [
      "yonke",
      "deshuesadero",
      "autopartes usadas",
      "partes usadas de auto",
      "auto salvage",
    ],
    googleNearbyTypes: ["auto_parts_store"],
    nearbyNameKeywords: [
      "yonke",
      "deshuesadero",
      "autopartes usadas",
      "auto partes usadas",
      "autopartes",
      "auto parts",
      "auto_parts_store",
      "refacciones usadas",
      "refacciones",
      "repuesto",
      "repuestos",
      "tienda de repuestos",
      "accesorios para automoviles",
      "accesorios para autos",
      "accesorios para camiones",
      "accesorios para trailers",
      "truck accessories",
      "partes para camiones",
      "partes para trailers",
      "partes usadas",
      "partes de auto usadas",
      "auto salvage",
      "salvage",
      "junkyard",
      "used auto parts",
    ],
    strictDirectMatch: true,
    excludeDirectKeywords: [
      "llanta",
      "llantas",
      "llantera",
      "llanteria",
      "tire",
      "taller",
      "mecanico",
      "mecanica",
      "car_repair",
      "lavado",
      "car wash",
      "renta",
      "rental",
      "agencia",
      "dealership",
      "estacionamiento",
      "parking",
    ],
  },
  {
    key: "llantera",
    aliases: ["llantera", "llanteria", "llantas", "venta de llantas", "tire shop"],
    tags: ["llantera", "llanteria", "llantas", "tire_shop", "tires"],
    label: "Llanteras",
    googleQueries: ["llantera", "llanteria", "venta de llantas", "tire shop"],
    googleLegacyQueries: ["llantera", "llanteria", "venta de llantas"],
    googleNearbyTypes: ["tire_shop"],
    nearbyNameKeywords: ["llantera", "llanteria", "llantas", "tire shop", "tires"],
    strictDirectMatch: true,
    excludeDirectKeywords: [
      "yonke",
      "deshuesadero",
      "autopartes usadas",
      "refaccionaria",
      "taller mecanico",
    ],
  },
  {
    key: "refaccionaria",
    aliases: [
      "refaccionaria",
      "refacciones",
      "autopartes",
      "auto partes",
      "partes para auto",
      "auto parts store",
    ],
    tags: [
      "refaccionaria",
      "refacciones",
      "autopartes",
      "auto_parts_store",
      "auto parts",
    ],
    label: "Refaccionarias y venta de autopartes nuevas",
    googleQueries: [
      "refaccionaria",
      "refacciones para auto",
      "autopartes nuevas",
      "partes para auto",
      "auto parts store",
    ],
    googleLegacyQueries: [
      "refaccionaria",
      "refacciones para auto",
      "autopartes",
      "auto parts store",
    ],
    googleNearbyTypes: ["auto_parts_store"],
    nearbyNameKeywords: [
      "refaccionaria",
      "refacciones",
      "autopartes",
      "auto partes",
      "partes para auto",
      "auto parts",
    ],
    strictDirectMatch: true,
    excludeDirectKeywords: [
      "yonke",
      "deshuesadero",
      "autopartes usadas",
      "refacciones usadas",
      "partes usadas",
      "auto salvage",
      "junkyard",
      "llantera",
      "llantas",
      "tire",
      "taller",
      "mecanico",
      "car_repair",
    ],
  },
];

const STORE_GENERIC_STOPWORDS = [
  "conveniencia",
  "abarrotes",
  "minisuper",
  "mini super",
  "supermercado",
  "oxxo",
  "kiosko",
  "market",
  "super",
];

const STORE_BIG_BOX_KEYWORDS = [
  "coppel",
  "woolworth",
  "suburbia",
  "milano",
  "del sol",
  "cya",
  "c&a",
  "sears",
  "liverpool",
];

const getStoreDescriptorProfileConfig = (descriptor = "") => {
  const value = sanitizeStoreDescriptor(descriptor);

  if (
    value.includes("ropa") ||
    value.includes("boutique") ||
    value.includes("moda") ||
    value.includes("caballero") ||
    value.includes("dama") ||
    value.includes("ninos") ||
    value.includes("niños") ||
    value.includes("infantil") ||
    value.includes("bebe") ||
    value.includes("bebes")
  ) {
    return {
      queryExpansions: [
        "tienda de ropa",
        "boutique",
        "boutique de ropa",
        "ropa de mujer",
        "ropa de hombre",
        "ropa de ninos",
        "ropa infantil",
        "clothing store",
        "fashion boutique",
      ],
      directKeywords: [
        "ropa",
        "boutique",
        "moda",
        "mujer",
        "dama",
        "hombre",
        "caballero",
        "ninos",
        "niños",
        "infantil",
        "bebe",
        "bebes",
        "clothing",
        "apparel",
        "fashion",
        "kids",
        "baby",
      ],
      nearbyTypes: ["clothing_store", "shoe_store", "department_store"],
    };
  }

  if (value.includes("deporte")) {
    return {
      queryExpansions: [
        "tienda de deportes",
        "articulos deportivos",
        "ropa deportiva",
        "sports store",
        "tenis deportivos",
      ],
      directKeywords: [
        "deporte",
        "deportivo",
        "deportes",
        "sport",
        "sports",
        "atletico",
        "atletica",
        "tenis",
        "running",
        "futbol",
        "basquetbol",
        "gym",
      ],
      nearbyTypes: [],
    };
  }

  if (value.includes("globo")) {
    return {
      queryExpansions: [
        "tienda de globos",
        "globos",
        "articulos para fiesta",
        "party store",
      ],
      directKeywords: [
        "globo",
        "globos",
        "fiesta",
        "party",
        "decoracion",
        "decoración",
      ],
      nearbyTypes: [],
    };
  }

  if (value.includes("estereo") || value.includes("audio")) {
    return {
      queryExpansions: [
        "tienda de estereo",
        "estereo automotriz",
        "audio para carro",
        "car audio",
      ],
      directKeywords: [
        "estereo",
        "stereo",
        "audio",
        "bocina",
        "bocinas",
        "car audio",
        "sonido",
      ],
      nearbyTypes: ["electronics_store"],
    };
  }

  return {
    queryExpansions: [`tienda de ${value}`, value],
    directKeywords: value.split(" ").filter(Boolean),
    nearbyTypes: [],
  };
};

const sanitizeStoreDescriptor = (value = "") =>
  normalize(value)
    .replace(/\b(tienda|de|para|y|e|la|el|los|las)\b/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const getSpecificStoreDescriptors = (business = "") => {
  const matches = [...business.matchAll(/tienda de ([a-z0-9ñ\s]+)/gi)];
  const rawDescriptors = matches
    .map((match) => sanitizeStoreDescriptor(match[1] || ""))
    .flatMap((descriptor) =>
      descriptor
        .split(/\btienda de\b|\/|,|;/)
        .map((part) => sanitizeStoreDescriptor(part))
    )
    .map((descriptor) => descriptor.split(/\s+/).slice(0, 3).join(" ").trim())
    .filter(Boolean)
    .filter(
      (descriptor) =>
        !STORE_GENERIC_STOPWORDS.some((stopword) => descriptor.includes(stopword))
    );

  return [...new Set(rawDescriptors)];
};

const buildSpecializedStoreProfile = (descriptors = [], businessType = "") => {
  const cleanedDescriptors = descriptors
    .map(sanitizeStoreDescriptor)
    .filter(Boolean);

  if (!cleanedDescriptors.length) return null;

  const descriptorKeywords = cleanedDescriptors.flatMap((descriptor) =>
    descriptor.split(" ").filter(Boolean)
  );
  const explicitQueries = cleanedDescriptors.map(
    (descriptor) => `tienda de ${descriptor}`
  );

  const queryExpansions = cleanedDescriptors.flatMap((descriptor) => {
    if (descriptor.includes("ropa")) {
      return [
        "tienda de ropa",
        "boutique",
        "boutique de ropa",
        "vestidos",
        "dresses",
        "dress shop",
        "ropa de mujer",
        "ropa de hombre",
        "ropa de ninos",
        "ropa infantil",
        "clothing store",
        "fashion boutique",
      ];
    }

    if (descriptor.includes("deporte")) {
      return [
        "tienda de deportes",
        "articulos deportivos",
        "ropa deportiva",
        "sports store",
      ];
    }

    if (descriptor.includes("globo")) {
      return [
        "tienda de globos",
        "globos",
        "articulos para fiesta",
        "party store",
      ];
    }

    if (descriptor.includes("estereo") || descriptor.includes("audio")) {
      return [
        "tienda de estereo",
        "estereo automotriz",
        "audio para carro",
        "car audio",
      ];
    }

    return [];
  });
  const expandedKeywords = queryExpansions.flatMap((query) =>
    normalize(query).split(" ").filter(Boolean)
  );

  const uniqueDescriptors = [...new Set(cleanedDescriptors)];
  const primaryLabel = uniqueDescriptors.slice(0, 2).join(" y ");

  return {
    key: `tienda_especializada_${uniqueDescriptors.join("_")}`,
    aliases: [
      ...uniqueDescriptors,
      ...descriptorKeywords,
      ...explicitQueries,
      businessType,
    ].filter(Boolean),
    tags: [...descriptorKeywords, ...expandedKeywords].filter(Boolean),
    label: `Tiendas de ${primaryLabel}`,
    googleQueries: [...new Set([...explicitQueries, ...queryExpansions])].slice(0, 10),
    googleLegacyQueries: [...new Set([...explicitQueries, ...queryExpansions])].slice(0, 10),
    googleNearbyTypes: cleanedDescriptors.some((descriptor) => descriptor.includes("ropa"))
      ? ["clothing_store", "shoe_store", "department_store"]
      : [],
    nearbyNameKeywords: [...new Set([...uniqueDescriptors, ...descriptorKeywords, ...expandedKeywords])],
    strictDirectMatch: true,
    excludeDirectKeywords: [
      "abarrotes",
      "minisuper",
      "mini super",
      "supermercado",
      "convenience_store",
      "grocery_store",
      "oxxo",
      "kiosko",
      "restaurant",
      "restaurante",
      "meal_takeaway",
      "cafe",
      "bakery",
      "farmacia",
      "pharmacy",
      "persiana",
      "iluminacion",
      "iluminación",
      "imprenta",
      "optica",
      "óptica",
      "marmol",
      "mármol",
      "pintura",
      "floral",
    ],
    deprioritizedNameKeywords: STORE_BIG_BOX_KEYWORDS,
  };
};

const getBusinessProfile = (businessType) => {
  const business = normalize(businessType);
  const spaProfile = businessProfiles.find((profile) => profile.key === "spa");

  if (
    spaProfile &&
    spaProfile.aliases.some((alias) => business.includes(alias))
  ) {
    return spaProfile;
  }

  const automotiveProfile = businessProfiles.find(
    (profile) =>
      ["yonke", "llantera", "refaccionaria"].includes(profile.key) &&
      profile.aliases.some((alias) => business.includes(alias))
  );

  if (automotiveProfile) {
    return automotiveProfile;
  }

  const specializedStoreProfile = buildSpecializedStoreProfile(
    getSpecificStoreDescriptors(business),
    businessType
  );

  if (specializedStoreProfile) {
    return specializedStoreProfile;
  }

  return (
    businessProfiles.find((profile) =>
      profile.aliases.some((alias) => business.includes(alias))
    ) || {
      key: business || "negocio",
      aliases: business ? [business] : [],
      tags: business ? [business] : [],
      label: businessType || "Negocio",
    }
  );
};

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const PAID_GOOGLE_ANALYSIS_ENABLED =
  process.env.REACT_APP_ENABLE_PAID_GOOGLE_ANALYSIS === "true";
let googlePlacesLoader;

const getDistanceMeters = (lat1, lng1, lat2, lng2) => {
  const earthRadius = 6371000;
  const toRad = (value) => (value * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);

  return earthRadius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

const getGooglePlaceName = (place) => {
  if (typeof place.name === "string") return place.name;
  if (typeof place.displayName === "string") return place.displayName;
  return place.displayName?.text || "";
};

const getGooglePlaceLocation = (place) => {
  const location = place.location;
  if (!location) return null;

  const lat =
    typeof location.lat === "function" ? location.lat() : location.lat;
  const lng =
    typeof location.lng === "function" ? location.lng() : location.lng;

  if (!Number.isFinite(Number(lat)) || !Number.isFinite(Number(lng))) {
    return null;
  }

  return {
    lat: Number(lat),
    lng: Number(lng),
  };
};

const getLegacyGooglePlaceLocation = (place) => {
  const location = place.geometry?.location;
  if (!location) return null;

  const lat =
    typeof location.lat === "function" ? location.lat() : location.lat;
  const lng =
    typeof location.lng === "function" ? location.lng() : location.lng;

  if (!Number.isFinite(Number(lat)) || !Number.isFinite(Number(lng))) {
    return null;
  }

  return {
    lat: Number(lat),
    lng: Number(lng),
  };
};

const loadGooglePlacesLibrary = async () => {
  if (!GOOGLE_MAPS_API_KEY || typeof window === "undefined") return null;

  if (window.google?.maps?.importLibrary) {
    return window.google.maps.importLibrary("places");
  }

  if (!googlePlacesLoader) {
    googlePlacesLoader = new Promise((resolve, reject) => {
      const existingScript = document.querySelector(
        "script[data-tulocal-google-maps]"
      );

      const finishLoading = async () => {
        try {
          if (!window.google?.maps?.importLibrary) {
            reject(new Error("Google Maps no cargo correctamente."));
            return;
          }

          resolve(await window.google.maps.importLibrary("places"));
        } catch (error) {
          reject(error);
        }
      };

      if (existingScript) {
        existingScript.addEventListener("load", finishLoading, { once: true });
        existingScript.addEventListener("error", reject, { once: true });
        return;
      }

      const script = document.createElement("script");
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=" +
        encodeURIComponent(GOOGLE_MAPS_API_KEY) +
        "&v=weekly&loading=async&libraries=places";
      script.async = true;
      script.defer = true;
      script.dataset.tulocalGoogleMaps = "true";
      script.addEventListener("load", finishLoading, { once: true });
      script.addEventListener("error", reject, { once: true });
      document.head.appendChild(script);
    });
  }

  return googlePlacesLoader;
};

const getMainTag = (tags = {}) => {
  if (tags.sport) return { key: "sport", value: tags.sport };
  if (tags.club) return { key: "club", value: tags.club };
  if (tags.healthcare) return { key: "healthcare", value: tags.healthcare };
  if (tags.shop) return { key: "shop", value: tags.shop };
  if (tags.amenity) return { key: "amenity", value: tags.amenity };
  if (tags.office) return { key: "office", value: tags.office };
  if (tags.tourism) return { key: "tourism", value: tags.tourism };
  if (tags.leisure) return { key: "leisure", value: tags.leisure };
  if (tags.highway) return { key: "highway", value: tags.highway };
  if (tags.public_transport) {
    return { key: "public_transport", value: tags.public_transport };
  }
  return { key: "", value: "" };
};

const getReadableType = (tagKey, tagValue) => {
  const labels = {
    hairdresser: "Barberia / estetica",
    beauty: "Belleza / spa",
    spa: "Spa",
    nails: "Uñas / belleza",
    massage: "Masajes / spa",
    martial_arts: "Artes marciales",
    karate: "Karate",
    taekwondo: "Taekwondo",
    judo: "Judo",
    boxing: "Box",
    kickboxing: "Kickboxing",
    sport: "Club deportivo",
    cafe: "Cafeteria",
    restaurant: "Restaurante",
    fast_food: "Comida rapida",
    food: "Comida",
    bakery: "Panaderia",
    pizza: "Pizza",
    burger: "Hamburguesas",
    tacos: "Taqueria",
    pharmacy: "Farmacia",
    chemist: "Farmacia",
    drugstore: "Farmacia",
    hardware: "Ferreteria",
    doityourself: "Ferreteria",
    tools: "Herramientas",
    trade: "Materiales / construccion",
    building_materials: "Materiales de construccion",
    paint: "Pintura",
    electrical: "Material electrico",
    plumbing: "Plomeria",
    construction: "Construccion",
    drinking_water: "Llenado de agua",
    water_point: "Llenado de agua",
    water: "Llenado de agua",
    school: "Escuela",
    college: "Escuela",
    university: "Universidad",
    language_school: "Escuela de idiomas",
    doctors: "Consultorio medico",
    dentist: "Dentista",
    clinic: "Clinica",
    hospital: "Hospital",
    medical: "Servicios medicos",
    healthcare: "Servicios de salud",
    park: "Parque",
    pitch: "Cancha / deporte",
    recreation_ground: "Area recreativa",
    bank: "Banco",
    atm: "Cajero",
    fuel: "Gasolinera",
    parking: "Estacionamiento",
    bus_stop: "Parada de camion",
    office: "Oficina",
    company: "Oficina / empresa",
    government: "Oficina de gobierno",
    convenience: "Minisuper / tienda",
    supermarket: "Supermercado",
    stationery: "Papeleria",
    copyshop: "Copias / impresion",
    fitness_centre: "Gimnasio",
    sports_centre: "Centro deportivo",
  };

  if (tagKey === "office") return labels[tagValue] || "Oficina";
  return labels[tagValue] || tagValue.replaceAll("_", " ");
};

const getSimpleCategory = (item = {}) => {
  const type = normalize(item.type);
  const tag = normalize(item.tag);
  const text = `${type} ${tag} ${normalize(item.name)}`;

  if (
    [
      "sushi",
      "japanese",
      "restaurant",
      "fast_food",
      "food",
      "cafe",
      "bakery",
      "pizza",
      "burger",
      "tacos",
      "taqueria",
      "hamburguesas",
      "restaurante",
    ].some((keyword) => text.includes(keyword))
  ) {
    return "Comida y restaurantes";
  }

  if (
    [
      "ropa",
      "boutique",
      "clothing",
      "apparel",
      "moda",
      "zapateria",
      "shoe",
      "tenis",
    ].some((keyword) => text.includes(keyword))
  ) {
    return "Ropa, boutiques y calzado";
  }

  if (
    [
      "convenience",
      "supermarket",
      "minisuper",
      "mini super",
      "tienda",
      "abarrotes",
    ].some((keyword) => text.includes(keyword))
  ) {
    return "Tiendas y abarrotes";
  }

  if (
    ["dentist", "dental", "odontologo", "odontologia", "nutriologa", "nutriologo", "nutricion", "nutricionista"].some(
      (keyword) => text.includes(keyword)
    )
  ) {
    return "Belleza y cuidado personal";
  }

  if (
    ["pharmacy", "chemist", "drugstore", "clinic", "hospital", "doctor", "salud", "farmacia"].some(
      (keyword) => text.includes(keyword)
    )
  ) {
    return "Salud y farmacias";
  }

  if (["school", "college", "university", "escuela"].some((keyword) => text.includes(keyword))) {
    return "Escuelas";
  }

  if (
    ["hardware", "ferreteria", "tools", "materiales", "construccion", "paint", "plomeria", "electrico"].some(
      (keyword) => text.includes(keyword)
    )
  ) {
    return "Ferreterias y materiales";
  }

  if (["fitness", "gym", "gimnasio", "sports_centre", "deportivo"].some((keyword) => text.includes(keyword))) {
    return "Gimnasios y deporte";
  }

  if (["office", "oficina", "company", "despacho"].some((keyword) => text.includes(keyword))) {
    return "Oficinas y servicios";
  }

  if (["beauty", "hairdresser", "barber", "spa", "nails", "belleza"].some((keyword) => text.includes(keyword))) {
    return "Belleza y cuidado personal";
  }

  if (item.section) return item.section;
  return item.type || "Otros";
};

const getSection = (tagKey, tagValue) => {
  const education = ["school", "college", "university", "language_school"];
  const services = [
    "pharmacy",
    "chemist",
    "drugstore",
    "hardware",
    "doityourself",
    "tools",
    "trade",
    "building_materials",
    "paint",
    "electrical",
    "plumbing",
    "construction",
    "drinking_water",
    "water_point",
    "water",
    "bank",
    "atm",
    "fuel",
    "parking",
  ];
  const food = [
    "cafe",
    "restaurant",
    "fast_food",
    "bakery",
    "bar",
    "food",
    "pizza",
    "burger",
    "tacos",
  ];
  const shops = [
    "convenience",
    "supermarket",
    "hairdresser",
    "beauty",
    "spa",
    "nails",
    "massage",
    "stationery",
    "copyshop",
  ];
  const health = [
    "doctors",
    "dentist",
    "clinic",
    "hospital",
    "medical",
    "healthcare",
  ];
  const sports = [
    "martial_arts",
    "karate",
    "taekwondo",
    "judo",
    "boxing",
    "kickboxing",
    "fitness_centre",
    "sports_centre",
    "sport",
  ];

  if (tagKey === "office") return "Oficinas";
  if (tagKey === "sport" || tagKey === "club" || sports.includes(tagValue)) {
    return "Gimnasios y deporte";
  }
  if (education.includes(tagValue)) return "Educacion";
  if (services.includes(tagValue)) return "Servicios";
  if (food.includes(tagValue)) return "Comida";
  if (shops.includes(tagValue)) return "Negocios";
  if (health.includes(tagValue)) return "Salud";
  if (tagKey === "tourism" || tagKey === "leisure") return "Entorno";

  return "Otros";
};

const isDirectCompetition = (tags, tagValue, name, profile) => {
  const readable = normalize(
    `${tagValue} ${name} ${tags.brand || ""} ${tags.operator || ""} ${Object.values(tags).join(" ")}`
  );

  return [...profile.tags, ...profile.aliases].some((keyword) =>
    readable.includes(normalize(keyword))
  );
};

const getGooglePlaceTypeText = (place) =>
  [
    place.primaryType,
    ...(Array.isArray(place.types) ? place.types : []),
  ]
    .filter(Boolean)
    .join(" ");

const isLikelyPrivatePlace = (place) => {
  const name = normalize(getGooglePlaceName(place) || place.name || "");

  return name.includes("casa de ") || name.includes("mi casa");
};

const isGoogleDirectCompetition = (place, profile) => {
  if (isLikelyPrivatePlace(place)) return false;

  const readable = normalize(
    `${getGooglePlaceName(place)} ${getGooglePlaceTypeText(place)}`
  );
  const excluded = profile.excludeDirectKeywords || [];
  const aliasKeywords = (profile.aliases || []).map(normalize).filter(Boolean);
  const matchedQuery = normalize(place.tag);
  const queryMatchesProfile = aliasKeywords.some(
    (keyword) => keyword.length > 3 && matchedQuery.includes(keyword)
  );
  const hasClearNameMatch = aliasKeywords.some(
    (keyword) => keyword.length > 3 && readable.includes(keyword)
  );

  if (excluded.some((keyword) => readable.includes(normalize(keyword)))) {
    return false;
  }

  if (queryMatchesProfile) {
    return true;
  }

  const directKeywords = [
    ...aliasKeywords,
    ...(profile.tags || []).map(normalize).filter(Boolean),
  ];

  return directKeywords.some((keyword) => readable.includes(keyword));
};

const looksLikeDirectCompetition = (place, profile) => {
  if (isLikelyPrivatePlace(place)) return false;

  const keywords = [
    ...(profile.nearbyNameKeywords || []),
    ...(profile.aliases || []),
    ...(profile.tags || []),
  ]
    .map(normalize)
    .filter(Boolean);
  const readable = normalize(
    `${place.name || ""} ${place.type || ""} ${place.groupType || ""} ${place.tag || ""} ${place.primaryType || ""} ${(place.types || []).join(" ")}`
  );

  return keywords.some((keyword) => readable.includes(keyword));
};

const getDisplayGroupType = (item) => {
  if (item.directCompetition && item.groupType) {
    return item.groupType;
  }

  const readable = normalize(
    `${item.name || ""} ${item.type || ""} ${item.groupType || ""} ${item.tag || ""} ${item.primaryType || ""} ${(item.types || []).join(" ")}`
  );

  if (
    [
      "dentista",
      "dental",
      "odontologo",
      "odontologia",
      "nutriologa",
      "nutriologo",
      "nutricion",
      "nutricionista",
    ].some((keyword) => readable.includes(keyword))
  ) {
    return "Belleza y cuidado personal";
  }

  return item.groupType || getSimpleCategory(item);
};

const summarizeGroups = (items) => {
  const groups = items.reduce((acc, item) => {
    const key = getDisplayGroupType(item);
    if (!acc[key]) {
      acc[key] = {
        type: key,
        total: 0,
        items: [],
      };
    }

    acc[key].total += 1;
    acc[key].items.push(item);
    return acc;
  }, {});

  return Object.values(groups).sort((a, b) => b.total - a.total);
};

const googleGeneralQueries = [
  { query: "restaurante", type: "Restaurante", groupType: "Comida y restaurantes", section: "Comida" },
  { query: "taqueria", type: "Taqueria", groupType: "Comida y restaurantes", section: "Comida" },
  { query: "mariscos", type: "Mariscos", groupType: "Comida y restaurantes", section: "Comida" },
  { query: "sushi", type: "Sushi", groupType: "Comida y restaurantes", section: "Comida" },
  { query: "cafeteria", type: "Cafeteria", groupType: "Comida y restaurantes", section: "Comida" },
  { query: "hamburguesas", type: "Hamburguesas", groupType: "Comida y restaurantes", section: "Comida" },
  { query: "panaderia", type: "Panaderia", groupType: "Comida y restaurantes", section: "Comida" },
  { query: "farmacia", type: "Farmacia", groupType: "Salud y farmacias", section: "Salud" },
  { query: "consultorio", type: "Consultorio", groupType: "Salud y farmacias", section: "Salud" },
  { query: "ferreteria", type: "Ferreteria", groupType: "Ferreterias y materiales", section: "Servicios" },
  { query: "tienda", type: "Tienda", groupType: "Tiendas y abarrotes", section: "Negocios" },
  { query: "oxxo", type: "OXXO / conveniencia", groupType: "Tiendas y abarrotes", section: "Negocios" },
  { query: "tienda de conveniencia", type: "Tienda de conveniencia", groupType: "Tiendas y abarrotes", section: "Negocios" },
  { query: "minisuper", type: "Minisuper / tienda", groupType: "Tiendas y abarrotes", section: "Negocios" },
  { query: "mini super", type: "Minisuper / tienda", groupType: "Tiendas y abarrotes", section: "Negocios" },
  { query: "supermercado", type: "Supermercado", groupType: "Tiendas y abarrotes", section: "Negocios" },
  { query: "mini super la mas querida", type: "Minisuper / tienda", groupType: "Tiendas y abarrotes", section: "Negocios" },
  { query: "abarrotes", type: "Abarrotes", groupType: "Tiendas y abarrotes", section: "Negocios" },
  { query: "papeleria", type: "Papeleria", groupType: "Papelerias e imprentas", section: "Servicios" },
  { query: "salon de belleza", type: "Salon de belleza", groupType: "Belleza y cuidado personal", section: "Servicios" },
  { query: "barberia", type: "Barberia", groupType: "Belleza y cuidado personal", section: "Servicios" },
  { query: "escuela", type: "Escuela", groupType: "Escuelas", section: "Educacion" },
  { query: "gimnasio", type: "Gimnasio", groupType: "Gimnasios y deporte", section: "Gimnasios y deporte" },
  { query: "oficina", type: "Oficina", groupType: "Oficinas y servicios", section: "Oficinas" },
  { query: "banco", type: "Banco", groupType: "Bancos y servicios", section: "Servicios" },
  { query: "gasolinera", type: "Gasolinera", groupType: "Servicios para autos", section: "Servicios" },
];

const makeGoogleQueries = (profile, businessType) => {
  const baseQueries =
    profile.googleQueries?.length > 0
      ? profile.googleQueries
      : [businessType, ...profile.aliases].filter(Boolean);

  return [...new Set(baseQueries.map((query) => query.trim()).filter(Boolean))]
    .slice(0, 10)
    .map((query) => ({
      query,
      type: profile.label,
      groupType: profile.label,
      section: "Competencia directa",
      directCompetition: true,
    }));
};

const isRelevantGoogleGeneralPlace = (place, config) => {
  if (config.groupType !== "Tiendas y abarrotes") return true;

  const readable = normalize(
    `${getGooglePlaceName(place)} ${getGooglePlaceTypeText(place)}`
  );
  const storeKeywords = [
    "convenience_store",
    "grocery_store",
    "supermarket",
    "liquor_store",
    "minisuper",
    "mini super",
    "mini súper",
    "abarrotes",
    "oxxo",
    "kiosko",
    "super rapido",
    "super rápido",
    "deposito",
    "depósito",
    "tecate",
    "la mas querida",
  ];
  const excludedKeywords = [
    "restaurant",
    "meal_takeaway",
    "cafe",
    "bakery",
    "farmacia",
    "pharmacy",
    "drugstore",
    "papeleria",
    "stationery",
    "copy",
    "ferreteria",
    "ferretería",
    "ferrereria",
    "hardware",
    "building_materials",
    "materiales",
    "taco",
    "taqueria",
    "asadero",
    "ensalada",
    "ensaladas",
    "salad",
    "ensalada",
    "marisco",
    "sushi",
    "hamburguesa",
    "pizza",
  ];
  const looksLikeStore = storeKeywords.some((keyword) =>
    readable.includes(keyword)
  );
  const looksExcluded = excludedKeywords.some((keyword) =>
    readable.includes(keyword)
  );

  return looksLikeStore && !looksExcluded;
};

const searchGoogleTextPlaces = async (
  lat,
  lng,
  queryConfigs,
  radiusMeters = RADIUS_METERS
) => {
  const placesLibrary = await loadGooglePlacesLibrary();
  const Place = placesLibrary?.Place || window.google?.maps?.places?.Place;

  if (!Place?.searchByText) return null;

  const results = [];

  for (const config of queryConfigs) {
   const { places = [] } = await Place.searchByText({
  textQuery: config.query,
  fields: [
    "id",
    "displayName",
    "location",
    "primaryType",
    "types",
    "businessStatus",
  ],
  locationBias: {
    center: { lat: Number(lat), lng: Number(lng) },
    radius: radiusMeters,
  },
  maxResultCount: config.maxResultCount || 20,
  language: "es-MX",
  region: "mx",
});

    places.forEach((place) => {
      if (place.businessStatus === "CLOSED_PERMANENTLY") return;

      const location = getGooglePlaceLocation(place);
      if (!location) return;

      const distance = getDistanceMeters(
        Number(lat),
        Number(lng),
        location.lat,
        location.lng
      );

      if (distance > radiusMeters) return;
      if (!isRelevantGoogleGeneralPlace(place, config)) return;

      results.push({
        id: place.id,
        name: getGooglePlaceName(place),
        type: config.type,
        groupType: config.groupType,
        section: config.section,
        tag: config.query,
        directCompetition: config.directCompetition,
        primaryType: place.primaryType,
        types: Array.isArray(place.types) ? place.types : [],
        source: "google",
        lat: location.lat,
        lng: location.lng,
        distanceMeters: Math.round(distance),
      });
    });
  }

  return results;
};

const makeGoogleNearbyTypeConfigs = (profile) =>
  (profile.googleNearbyTypes || []).map((type) => ({
    type,
    label: profile.label,
    groupType: profile.label,
    section: "Competencia directa",
    keywords: profile.nearbyNameKeywords || profile.aliases || [],
  }));

const searchGoogleNearbyPlaces = async (
  lat,
  lng,
  typeConfigs,
  radiusMeters = RADIUS_METERS
) => {
  const placesLibrary = await loadGooglePlacesLibrary();
  const Place = placesLibrary?.Place || window.google?.maps?.places?.Place;

  if (!Place?.searchNearby || !typeConfigs?.length) return [];

  const results = [];

  for (const config of typeConfigs) {
    try {
      const { places = [] } = await Place.searchNearby({
        fields: [
          "id",
          "displayName",
          "location",
          "primaryType",
          "types",
          "businessStatus",
        ],
        locationRestriction: {
          center: { lat: Number(lat), lng: Number(lng) },
          radius: radiusMeters,
        },
        includedPrimaryTypes: [config.type],
        maxResultCount: 20,
        rankPreference: "DISTANCE",
        language: "es-MX",
        region: "mx",
      });

      places.forEach((place) => {
        if (place.businessStatus === "CLOSED_PERMANENTLY") return;

        const location = getGooglePlaceLocation(place);
        if (!location) return;

        const distance = getDistanceMeters(
          Number(lat),
          Number(lng),
          location.lat,
          location.lng
        );

        if (distance > radiusMeters) return;

        const readable = normalize(
          `${getGooglePlaceName(place)} ${getGooglePlaceTypeText(place)}`
        );
        const matchesName = (config.keywords || [])
          .map(normalize)
          .filter(Boolean)
          .some((keyword) => readable.includes(keyword));

        if (config.type === "restaurant" && !matchesName) return;

        results.push({
          id: place.id,
          name: getGooglePlaceName(place),
          type: config.label,
          groupType: config.groupType,
          section: config.section,
          tag: config.type,
          directCompetition: true,
          primaryType: place.primaryType,
          types: Array.isArray(place.types) ? place.types : [],
          source: "google",
          lat: location.lat,
          lng: location.lng,
          distanceMeters: Math.round(distance),
        });
      });
    } catch (error) {
      console.warn("Tipo de busqueda cercana no disponible:", config.type, error);
    }
  }

  return results;
};

const searchGoogleLegacyNearbyPlaces = async (
  lat,
  lng,
  profile,
  radiusMeters = RADIUS_METERS
) => {
  await loadGooglePlacesLibrary();

  const PlacesService = window.google?.maps?.places?.PlacesService;
  const PlacesServiceStatus = window.google?.maps?.places?.PlacesServiceStatus;
  const LatLng = window.google?.maps?.LatLng;

  if (!PlacesService || !PlacesServiceStatus || !LatLng) return [];

  const queries = [
    ...(profile.googleLegacyQueries || []),
  ]
    .map((query) => query.trim())
    .filter(Boolean)
    .filter((query, index, list) => list.indexOf(query) === index)
    .slice(0, 10);
  const service = new PlacesService(document.createElement("div"));
  const results = [];

  const runQuery = (keyword) =>
    new Promise((resolve) => {
      let pageCount = 0;

      const collectPage = (places = [], status, pagination) => {
        if (
          status !== PlacesServiceStatus.OK &&
          status !== PlacesServiceStatus.ZERO_RESULTS
        ) {
          resolve();
          return;
        }

        places.forEach((place) => {
          if (place.business_status === "CLOSED_PERMANENTLY") return;

          const location = getLegacyGooglePlaceLocation(place);
          if (!location) return;

          const distance = getDistanceMeters(
            Number(lat),
            Number(lng),
            location.lat,
            location.lng
          );

          if (distance > radiusMeters) return;

          results.push({
            id: place.place_id,
            name: place.name || "",
            type: profile.label,
            groupType: profile.label,
            section: "Competencia directa",
            tag: keyword,
            directCompetition: true,
            primaryType: place.types?.[0],
            types: Array.isArray(place.types) ? place.types : [],
            source: "google",
            lat: location.lat,
            lng: location.lng,
            distanceMeters: Math.round(distance),
          });
        });

        pageCount += 1;

        if (pagination?.hasNextPage && pageCount < 3) {
          setTimeout(() => pagination.nextPage(), 1800);
          return;
        }

        resolve();
      };

      service.nearbySearch(
        {
          location: new LatLng(Number(lat), Number(lng)),
          radius: radiusMeters,
          keyword,
          type: "restaurant",
        },
        collectPage
      );
    });

  for (const query of queries) {
    await runQuery(query);
  }

  return results;
};

const uniqueByPlace = (items) => {
  const seen = new Set();

  return items.filter((item) => {
    const key =
      item.id ||
      `${normalize(item.name)}-${item.type}-${Math.round(
        item.distanceMeters || 0
      )}`;

    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

const getDirectPlaceRank = (place, profile) => {
  const readable = normalize(
    `${place.name || ""} ${place.primaryType || ""} ${(place.types || []).join(" ")}`
  );
  const deprioritized = (profile.deprioritizedNameKeywords || [])
    .map(normalize)
    .filter(Boolean);

  return deprioritized.some((keyword) => readable.includes(keyword)) ? 1 : 0;
};

const isProfileDirectPlace = (place, profile) => {
  if (isLikelyPrivatePlace(place)) return false;

  const readable = normalize(
    `${place.name || ""} ${place.primaryType || ""} ${(place.types || []).join(" ")}`
  );
  const excluded = (profile.excludeDirectKeywords || [])
    .map(normalize)
    .filter(Boolean);

  if (excluded.some((keyword) => readable.includes(keyword))) {
    return false;
  }

  const keywords = [
    ...(profile.nearbyNameKeywords || []),
    ...(profile.aliases || []),
    ...(profile.tags || []),
  ]
    .map(normalize)
    .filter(Boolean);

  return keywords.some((keyword) => readable.includes(keyword));
};

const getServerGooglePlacesAnalysis = async (
  lat,
  lng,
  businessType,
  profile,
  options = {}
) => {
  if (typeof window === "undefined") return null;
  if (["localhost", "127.0.0.1"].includes(window.location.hostname)) {
    return null;
  }

  const params = new URLSearchParams({
    lat: String(lat),
    lng: String(lng),
    businessType: businessType || "",
  });
  if (options.propertySubmissionId) {
    params.set("propertySubmissionId", options.propertySubmissionId);
  }
  if (options.propertyPublicId) {
    params.set("propertyPublicId", options.propertyPublicId);
  }
  const response = await fetch(`/api/nearby-places?${params.toString()}`, {
    cache: "no-store",
  });

  if (!response.ok) return null;

  const contentType = response.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) {
    return null;
  }

  const data = await response.json();
  if (data.skipped || data.cacheOnly) {
    const cacheMissError = new Error(
      "No hay un analisis guardado para esta propiedad y giro."
    );
    cacheMissError.code = "ZONE_CACHE_MISS";
    throw cacheMissError;
  }
  const directPlaces = uniqueByPlace(data.directPlaces || [])
    .filter((place) =>
      profile.strictDirectMatch ? isProfileDirectPlace(place, profile) : true
    )
    .sort((a, b) => {
      const rankDiff = getDirectPlaceRank(a, profile) - getDirectPlaceRank(b, profile);
      if (rankDiff !== 0) return rankDiff;
      return (a.distanceMeters || 0) - (b.distanceMeters || 0);
    });
  const directPlaces1Km = directPlaces.filter(
    (place) => Number(place.distanceMeters || 0) <= RADIUS_METERS
  );
  const otherBusinessItems = uniqueByPlace(data.otherBusinesses || []);
  const allBusinessItems = [...directPlaces, ...otherBusinessItems];

  return {
    radiusMeters: data.radiusMeters || RADIUS_METERS,
    businessType,
    source: data.cache?.hit ? "supabase-cache" : "server-google",
    cache: data.cache,
    googleConsultedAt: data.googleConsultedAt,
    confidence: data.confidence,
    competitionLabel: data.competitionLabel || profile.label,
    directCompetition: {
      total: directPlaces.length,
      nearbyTotal: directPlaces1Km.length,
      expandedTotal: directPlaces.length,
      nearbyRadiusMeters: RADIUS_METERS,
      expandedRadiusMeters:
        data.directCompetitionRadiusMeters || DIRECT_COMPETITION_RADIUS_METERS,
      groups: summarizeGroups(directPlaces),
      items: directPlaces.slice(0, 12),
    },
    otherBusinesses: {
      total: otherBusinessItems.length,
      groups: summarizeGroups(otherBusinessItems),
    },
    categories: [],
    mobility: {
      vehicular: "Sin estimar",
      pedestrian: "Sin estimar",
      roads: [],
      majorRoads: [],
      transitStops: 0,
      parkingCount: 0,
    },
    recommendation: buildRecommendation({
      directCompetition: directPlaces1Km,
      groupedItems: allBusinessItems,
      majorRoads: [],
      transitStops: 0,
      parkingCount: 0,
    }),
  };
};

const getServerPopulationAnalysis = async (lat, lng) => {
  if (typeof window === "undefined") return null;

  const params = new URLSearchParams({
    lat: String(lat),
    lng: String(lng),
    radii: "1000,5000",
  });
  const response = await fetch(`/api/zone-population?${params.toString()}`, {
    cache: "no-store",
  });

  if (!response.ok) return null;

  const contentType = response.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) {
    return null;
  }

  return response.json();
};

const getClientPopulationAnalysis = async (lat, lng) => {
  const data = await import("../data/inegi-culiacan-manzanas.json");
  const inegiBlocks = data.default || data;
  const blocks = inegiBlocks.blocks || [];
  const radii = [1000, 5000].map((radiusMeters) => {
    const includedBlocks = blocks.filter((block) => {
      const distance = getDistanceMeters(lat, lng, block.lat, block.lng);
      return distance <= radiusMeters;
    });

    return {
      radiusMeters,
      population: includedBlocks.reduce(
        (total, block) => total + (Number(block.population) || 0),
        0
      ),
      homes: includedBlocks.reduce(
        (total, block) => total + (Number(block.homes) || 0),
        0
      ),
      blocks: includedBlocks.length,
    };
  });

  return {
    source: inegiBlocks.source,
    sourceUrl: inegiBlocks.sourceUrl,
    entity: inegiBlocks.entity,
    municipality: inegiBlocks.municipality,
    locality: inegiBlocks.locality,
    method: inegiBlocks.method,
    totalBlocksAvailable: inegiBlocks.totalBlocks,
    radii,
  };
};

const withPopulationAnalysis = async (analysis, lat, lng) => {
  if (!analysis) return analysis;

  try {
    const population =
      (await getServerPopulationAnalysis(lat, lng)) ||
      (await getClientPopulationAnalysis(lat, lng));
    return population ? { ...analysis, population } : analysis;
  } catch (error) {
    try {
      const population = await getClientPopulationAnalysis(lat, lng);
      return population ? { ...analysis, population } : analysis;
    } catch (fallbackError) {
      console.warn("Poblacion INEGI no disponible.", error, fallbackError);
      return analysis;
    }
  }
};

const getGooglePlacesAnalysis = async (lat, lng, businessType, profile) => {
  if (!GOOGLE_MAPS_API_KEY) return null;

  const directTextPlaces =
    (await searchGoogleTextPlaces(
      lat,
      lng,
      makeGoogleQueries(profile, businessType),
      DIRECT_COMPETITION_RADIUS_METERS
    )) || [];
  const directNearbyPlaces = await searchGoogleNearbyPlaces(
    lat,
    lng,
    makeGoogleNearbyTypeConfigs(profile),
    DIRECT_COMPETITION_RADIUS_METERS
  );
  const directLegacyPlaces = await searchGoogleLegacyNearbyPlaces(
    lat,
    lng,
    profile,
    DIRECT_COMPETITION_RADIUS_METERS
  );

  const generalPlaces = uniqueByPlace(
    (await searchGoogleTextPlaces(lat, lng, googleGeneralQueries)) || []
  );

  const directCandidates = uniqueByPlace([
    ...directTextPlaces,
    ...directNearbyPlaces,
    ...directLegacyPlaces,
    ...generalPlaces.filter((place) =>
      looksLikeDirectCompetition(place, profile)
    ),
  ])
    .filter((place) =>
      profile.strictDirectMatch ? isProfileDirectPlace(place, profile) : true
    )
    .sort((a, b) => {
      const rankDiff = getDirectPlaceRank(a, profile) - getDirectPlaceRank(b, profile);
      if (rankDiff !== 0) return rankDiff;
      return (a.distanceMeters || 0) - (b.distanceMeters || 0);
    });

  const directPlaces = directCandidates.map((place) => ({
    ...place,
    type: profile.label,
    groupType: profile.label,
    section: "Competencia directa",
    directCompetition: true,
  }));
  const directPlaces1Km = directPlaces.filter(
    (place) => Number(place.distanceMeters || 0) <= RADIUS_METERS
  );
  const relatedPlaces = [];

  const directKeys = new Set(
    directPlaces.map((place) => place.id || normalize(place.name))
  );

  const otherBusinessItems = uniqueByPlace(
    [...relatedPlaces, ...generalPlaces].filter(
      (place) => !directKeys.has(place.id || normalize(place.name))
    )
  );

  const allBusinessItems = [...directPlaces, ...otherBusinessItems];

  return {
    radiusMeters: RADIUS_METERS,
    businessType,
    source: "google",
    competitionLabel: profile.label,
    directCompetition: {
      total: directPlaces.length,
      nearbyTotal: directPlaces1Km.length,
      expandedTotal: directPlaces.length,
      nearbyRadiusMeters: RADIUS_METERS,
      expandedRadiusMeters: DIRECT_COMPETITION_RADIUS_METERS,
      groups: summarizeGroups(directPlaces),
      items: directPlaces.slice(0, 12),
    },
    otherBusinesses: {
      total: otherBusinessItems.length,
      groups: summarizeGroups(otherBusinessItems),
    },
    categories: [],
    mobility: {
      vehicular: "Sin estimar",
      pedestrian: "Sin estimar",
      roads: [],
      majorRoads: [],
      transitStops: 0,
      parkingCount: 0,
    },
    recommendation: buildRecommendation({
      directCompetition: directPlaces,
      groupedItems: allBusinessItems,
      majorRoads: [],
      transitStops: 0,
      parkingCount: 0,
    }),
  };
};

const getFlowLabel = (score) => {
  if (score >= 75) return "Alto";
  if (score >= 45) return "Medio";
  return "Bajo";
};

const buildRecommendation = ({
  directCompetition,
  groupedItems,
  majorRoads,
  transitStops,
  parkingCount,
}) => {
  const businessDensity = groupedItems.length;
  const demandSignals =
    businessDensity + majorRoads.length * 4 + transitStops * 2 + parkingCount;
  const competitionCount = directCompetition.length;

  let viability = "Zona con potencial";
  const positives = [];
  const cautions = [];

  if (majorRoads.length > 0) {
    positives.push("Hay vialidades importantes cerca, lo que ayuda al acceso.");
  }

  if (businessDensity >= 12) {
    positives.push("Existe actividad comercial alrededor del local.");
  }

  if (transitStops > 0) {
    positives.push("Hay paradas o puntos de transporte cercanos.");
  }

  if (parkingCount > 0) {
    positives.push("Se detectaron estacionamientos o puntos para autos cerca.");
  }

  if (competitionCount === 0) {
    positives.push("No aparece competencia directa registrada hasta 5 km.");
  } else if (competitionCount <= 3) {
    cautions.push("Hay competencia directa, pero no parece saturada.");
  } else {
    viability = "Revisar con cuidado";
    cautions.push("La competencia directa aparece alta hasta 5 km.");
  }

  if (demandSignals < 10) {
    cautions.push("Los datos abiertos muestran poca actividad cercana.");
  }

  if (competitionCount <= 2 && demandSignals >= 15) {
    viability = "Buena oportunidad";
  }

  return {
    viability,
    positives,
    cautions,
    summary:
      "Esta lectura es una estimacion con datos abiertos del mapa. Sirve para comparar zonas, no como conteo oficial.",
  };
};

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const isWeakAnalysis = (analysis, businessType = "") => {
  if (!analysis) return true;

  const business = normalize(businessType);
  if (!business) {
    return (analysis.directCompetition?.total || 0) === 0 &&
      (analysis.otherBusinesses?.total || 0) === 0;
  }

  const directTotal = analysis.directCompetition?.total || 0;
  const namedItems = analysis.directCompetition?.items?.filter((item) => item?.name)?.length || 0;

  return directTotal === 0 || (directTotal <= 1 && namedItems <= 1);
};

const chooseBetterAnalysis = (first, second) => {
  if (!first) return second;
  if (!second) return first;

  const firstDirect = first.directCompetition?.total || 0;
  const secondDirect = second.directCompetition?.total || 0;
  if (secondDirect !== firstDirect) {
    return secondDirect > firstDirect ? second : first;
  }

  const firstOther = first.otherBusinesses?.total || 0;
  const secondOther = second.otherBusinesses?.total || 0;
  return secondOther > firstOther ? second : first;
};

const shouldSkipOsmFallback = (profile, businessType = "") => {
  const business = normalize(businessType);

  return (
    profile?.strictDirectMatch ||
    Boolean(business)
  );
};

const createEmptyAnalysis = (profile, businessType = "") => ({
  radiusMeters: RADIUS_METERS,
  businessType,
  competitionLabel: profile?.label || businessType || "Negocio",
  directCompetition: {
    total: 0,
    groups: [],
    items: [],
  },
  otherBusinesses: {
    total: 0,
    groups: [],
  },
  categories: [],
  mobility: {
    vehicular: "Sin estimar",
    pedestrian: "Sin estimar",
    roads: [],
    majorRoads: [],
    transitStops: 0,
    parkingCount: 0,
  },
  recommendation: {
    viability: "Analisis incompleto",
    positives: [],
    cautions: [
      "No se pudo completar un analisis confiable con las fuentes disponibles en este momento.",
    ],
    summary:
      "Intenta de nuevo en unos segundos para obtener una lectura mas estable.",
  },
});

export const getNearbyPlaces = async (
  lat,
  lng,
  businessType = "",
  options = {}
) => {
  if (!lat || !lng) return null;

  const profile = getBusinessProfile(businessType);
  let bestAnalysis = null;

  try {
    const serverAnalysis = await getServerGooglePlacesAnalysis(
      lat,
      lng,
      businessType,
      profile,
      options
    );

    bestAnalysis = chooseBetterAnalysis(bestAnalysis, serverAnalysis);
  } catch (error) {
    if (error?.code === "ZONE_CACHE_MISS") {
      throw error;
    }
    if (!["localhost", "127.0.0.1"].includes(window.location.hostname)) {
      console.warn("API interna de zona no disponible, usando navegador.", error);
    }
  }

  if (!PAID_GOOGLE_ANALYSIS_ENABLED) {
    if (bestAnalysis) {
      return withPopulationAnalysis(bestAnalysis, lat, lng);
    }

    const cacheMissError = new Error(
      "No hay un analisis guardado para esta propiedad y giro. Las consultas a Google estan pausadas."
    );
    cacheMissError.code = "ZONE_CACHE_MISS";
    throw cacheMissError;
  }

  try {
    const googleAnalysis = await getGooglePlacesAnalysis(
      lat,
      lng,
      businessType,
      profile
    );

    bestAnalysis = chooseBetterAnalysis(bestAnalysis, googleAnalysis);
  } catch (error) {
    console.warn("Google Places no disponible, usando OpenStreetMap.", error);
  }

  if (bestAnalysis && !isWeakAnalysis(bestAnalysis, businessType)) {
    return withPopulationAnalysis(bestAnalysis, lat, lng);
  }

  if (GOOGLE_MAPS_API_KEY || !["localhost", "127.0.0.1"].includes(window.location.hostname)) {
    await wait(900);

    try {
      const retryServerAnalysis = await getServerGooglePlacesAnalysis(
        lat,
        lng,
        businessType,
        profile,
        options
      );
      bestAnalysis = chooseBetterAnalysis(bestAnalysis, retryServerAnalysis);
    } catch (error) {
      console.warn("Reintento de API interna sin mejora.", error);
    }

    try {
      const retryGoogleAnalysis = await getGooglePlacesAnalysis(
        lat,
        lng,
        businessType,
        profile
      );
      bestAnalysis = chooseBetterAnalysis(bestAnalysis, retryGoogleAnalysis);
    } catch (error) {
      console.warn("Reintento de Google Places sin mejora.", error);
    }
  }

  if (bestAnalysis) {
    return withPopulationAnalysis(bestAnalysis, lat, lng);
  }

  if (shouldSkipOsmFallback(profile, businessType)) {
    return withPopulationAnalysis(createEmptyAnalysis(profile, businessType), lat, lng);
  }

  const query = `
  [out:json][timeout:25];
  (
    node(around:${RADIUS_METERS},${lat},${lng})["amenity"];
    node(around:${RADIUS_METERS},${lat},${lng})["shop"];
    node(around:${RADIUS_METERS},${lat},${lng})["office"];
    node(around:${RADIUS_METERS},${lat},${lng})["sport"];
    node(around:${RADIUS_METERS},${lat},${lng})["club"];
    node(around:${RADIUS_METERS},${lat},${lng})["healthcare"];
    node(around:${RADIUS_METERS},${lat},${lng})["tourism"];
    node(around:${RADIUS_METERS},${lat},${lng})["leisure"];
    node(around:${RADIUS_METERS},${lat},${lng})["highway"];
    node(around:${RADIUS_METERS},${lat},${lng})["public_transport"];

    way(around:${RADIUS_METERS},${lat},${lng})["amenity"];
    way(around:${RADIUS_METERS},${lat},${lng})["shop"];
    way(around:${RADIUS_METERS},${lat},${lng})["office"];
    way(around:${RADIUS_METERS},${lat},${lng})["sport"];
    way(around:${RADIUS_METERS},${lat},${lng})["club"];
    way(around:${RADIUS_METERS},${lat},${lng})["healthcare"];
    way(around:${RADIUS_METERS},${lat},${lng})["tourism"];
    way(around:${RADIUS_METERS},${lat},${lng})["leisure"];
    way(around:${RADIUS_METERS},${lat},${lng})["highway"];
    way(around:${RADIUS_METERS},${lat},${lng})["public_transport"];
  );
  out center tags;
  `;

  const url =
    "https://overpass-api.de/api/interpreter?data=" +
    encodeURIComponent(query);

  const res = await fetch(url);

  if (!res.ok) {
    throw new Error("No se pudo consultar el entorno de esta zona.");
  }

  const data = await res.json();
  const elements = data.elements || [];

  const seen = new Set();
  const places = [];
  const directCompetition = [];
  const roads = [];
  let transitStops = 0;
  let parkingCount = 0;

  elements.forEach((item) => {
    const tags = item.tags || {};
    const { key: tagKey, value: tagValue } = getMainTag(tags);

    if (!tagValue) return;

    const name = (tags.name || tags["name:es"] || "").trim();
    const latVal = item.lat || item.center?.lat;
    const lonVal = item.lon || item.center?.lon;
    const uniqueKey = `${tagKey}-${tagValue}-${name}-${latVal}-${lonVal}`;

    if (seen.has(uniqueKey)) return;
    seen.add(uniqueKey);

    if (tagKey === "highway") {
      roads.push({
        name: name || "Vialidad sin nombre registrado",
        type: tagValue,
      });
      return;
    }

    if (tagValue === "bus_stop" || tagKey === "public_transport") {
      transitStops += 1;
    }

    if (tagValue === "parking") {
      parkingCount += 1;
    }

    const type = getReadableType(tagKey, tagValue);
    const section = getSection(tagKey, tagValue);
    const direct = isDirectCompetition(tags, tagValue, name, profile);
    const place = {
      name,
      type,
      groupType: getSimpleCategory({ name, type, tag: tagValue, section }),
      section,
      tag: tagValue,
      directCompetition: direct,
      lat: latVal,
      lng: lonVal,
      distanceMeters: Math.round(getDistanceMeters(Number(lat), Number(lng), latVal, lonVal)),
    };

    places.push(place);

    if (direct) {
      directCompetition.push(place);
    }
  });

  const businessItems = places.filter((place) => place.section !== "Otros");
  const otherBusinessItems = businessItems.filter(
    (place) => !place.directCompetition && place.section !== "Entorno"
  );
  const sectionGroups = businessItems.reduce((acc, item) => {
    if (!acc[item.section]) acc[item.section] = [];
    acc[item.section].push(item);
    return acc;
  }, {});

  const majorRoadTypes = ["trunk", "primary", "secondary", "tertiary"];
  const majorRoads = roads.filter((road) =>
    majorRoadTypes.includes(road.type)
  );

  const vehicularScore = Math.min(
    100,
    majorRoads.length * 25 + roads.length * 4 + parkingCount * 8
  );
  const pedestrianScore = Math.min(
    100,
    businessItems.length * 4 + transitStops * 10
  );

  const recommendation = buildRecommendation({
    directCompetition,
    groupedItems: businessItems,
    majorRoads,
    transitStops,
    parkingCount,
  });

  return withPopulationAnalysis({
    radiusMeters: RADIUS_METERS,
    businessType,
    competitionLabel: profile.label,
    directCompetition: {
      total: directCompetition.length,
      groups: summarizeGroups(directCompetition),
      items: directCompetition.slice(0, 12),
    },
    otherBusinesses: {
      total: otherBusinessItems.length,
      groups: summarizeGroups(otherBusinessItems),
    },
    categories: Object.entries(sectionGroups)
      .map(([section, items]) => ({
        section,
        total: items.length,
        groups: summarizeGroups(items),
      }))
      .sort((a, b) => b.total - a.total),
    mobility: {
      vehicular: getFlowLabel(vehicularScore),
      pedestrian: getFlowLabel(pedestrianScore),
      vehicularScore,
      pedestrianScore,
      roads: summarizeGroups(
        roads.map((road) => ({
          name: road.name,
          type: road.type.replaceAll("_", " "),
          section: "Vialidades",
        }))
      ),
      majorRoads: majorRoads.slice(0, 8),
      transitStops,
      parkingCount,
    },
    recommendation,
  }, lat, lng);
};
